import { semantic } from '@arcade/web'
import * as tokens from '@cash-design-system/tokens'

import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'
import { monochromeArcadeColors } from './monochromeColors'

export const localArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  ...monochromeArcadeColors,
  toggleActiveBackgroundDefault: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
  toggleInactiveBackgroundDefault: {
    light: tokens.ColorPaletteGray85,
    dark: tokens.ColorPaletteGray40,
  },
  toggleActiveBackgroundDisabled: {
    light: tokens.ColorPaletteBlack,
    dark: tokens.ColorPaletteWhite,
  },
  toggleKnobBackgroundDefault: {
    light: tokens.ColorPaletteWhite,
    dark: tokens.ColorPaletteBlack,
  },
}

export const localMooncakeColors = {
  progressBarFill: {
    light: semantic.iconSuccess.light,
    dark: semantic.iconSuccess.dark,
  },
} as ThemeColorsOverride
